import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "currentTime", "droppedMoment", "_incrementCurrentTime", "isCurrentDay"];
import { callIfPossible } from 'UIComponents/core/Functions';
import CurrentTimeIndicator from '../components/CurrentTimeIndicator';
import { HoverMarker } from './HoverStyles';
import { DayColumn } from './DayColumnStyles';
import { DropTarget } from '../dragDrop/internal/DropTarget';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WeekDay = props => {
  const {
      children,
      currentTime,
      droppedMoment,
      _incrementCurrentTime,
      isCurrentDay
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    childRef
  } = rest;
  return /*#__PURE__*/_jsx(DropTarget, {
    droppedMoment: droppedMoment,
    viewType: "DAY",
    render: ({
      isSameTime,
      isOver,
      canDropResult: canDrop,
      containerRef,
      dropTarget,
      hoverMarkerStyle
    }) => /*#__PURE__*/_jsxs(DayColumn, {
      ref: ref => {
        callIfPossible(childRef, ref);
        containerRef.current = ref;
      },
      children: [/*#__PURE__*/_jsx(CurrentTimeIndicator, {
        _incrementCurrentTime: _incrementCurrentTime,
        currentTime: currentTime,
        isCurrentDay: isCurrentDay
      }), /*#__PURE__*/_jsx(HoverMarker, {
        canDrop: canDrop,
        isOver: isOver,
        isSameTime: isSameTime,
        hoverMarkerStyle: hoverMarkerStyle
      }), dropTarget, children]
    })
  });
};
export default WeekDay;